module.exports = __webpack_public_path__ + "11a51263db43866d4fafe27f6216c293.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GI.svg
// module id = kKsu
// module chunks = 0